/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UserAccountResendInvitationRequest
 */
export interface UserAccountResendInvitationRequest {
    /**
     *
     * @type {number}
     * @memberof UserAccountResendInvitationRequest
     */
    userAccountId?: number;
    /**
     *
     * @type {string}
     * @memberof UserAccountResendInvitationRequest
     */
    invitationMessage?: string;
}

/**
 * Check if a given object implements the UserAccountResendInvitationRequest interface.
 */
export function instanceOfUserAccountResendInvitationRequest(
    value: object,
): value is UserAccountResendInvitationRequest {
    return true;
}

export function UserAccountResendInvitationRequestFromJSON(
    json: any,
): UserAccountResendInvitationRequest {
    return UserAccountResendInvitationRequestFromJSONTyped(json, false);
}

export function UserAccountResendInvitationRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UserAccountResendInvitationRequest {
    if (json == null) {
        return json;
    }
    return {
        userAccountId:
            json["userAccountId"] == null ? undefined : json["userAccountId"],
        invitationMessage:
            json["invitationMessage"] == null
                ? undefined
                : json["invitationMessage"],
    };
}

export function UserAccountResendInvitationRequestToJSON(
    value?: UserAccountResendInvitationRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        userAccountId: value["userAccountId"],
        invitationMessage: value["invitationMessage"],
    };
}
